import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={43}
    height={43}
    fill="none"
    {...props}
  >
    <circle
      cx={21.5}
      cy={21.5}
      r={21}
      stroke="#0FBAB5"
      transform="matrix(-1 0 0 1 43 0)"
    />
    <path stroke="#0FBAB5" d="m25 15-7.5 7 7 6.5" />
  </svg>
)
export default SvgComponent
